import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { patientData } from 'merlin-core';
import { ApiService } from 'merlin-library';
import { BehaviorSubject } from 'rxjs';
import { ClinicianApiEndPointConstants } from '../../utilitites/api-end-point-constants';

@Injectable({
    providedIn: 'root',
})
export class PatientTransferRequestClinicService {
    public token = localStorage.getItem('token');

    public patientProfileObs$: BehaviorSubject<any> = new BehaviorSubject(null);
    constructor(private apiService: ApiService, private http: HttpClient) {}

    getRequests() {
        return this.apiService.get(`${ClinicianApiEndPointConstants.epPatientFinder}`);
    }

    cancelRequest(patientId) {
        return this.apiService.delete(
            `${ClinicianApiEndPointConstants.deletTransferRequestApi}/${patientId}/transfer`
        );
    }

    enrollPatients(patientId) {
        return this.apiService.post(
            `${ClinicianApiEndPointConstants.activatorFindTransferPatient}?patientId=${patientId}`,
            {}
        );
    }

    getPatientProfile() {
        return this.patientProfileObs$.asObservable();
    }

    setPatientProfile(profileData: any) {
        this.patientProfileObs$.next(profileData);
    }
}
